<template>
  <router-link :to="{name: 'desc-news', params: { userId: this.link}}" class="btn-post"  variant="link" v-if="!isMobile" >
  <b-card class="card-post">
    <div>
      <p class="date">
        <PuSkeleton :loading="isLoading" :count="1" width='90px'>                        
          {{ date | moment(true) }}
        </PuSkeleton>
      </p>
      <h4 class="title">
        <PuSkeleton :loading="isLoading" :count="1">                                
          {{title}}
        </PuSkeleton>  
      </h4>
      <p class="desc">
        <PuSkeleton :loading="isLoading" :count="3">        
          {{desc}}
        </PuSkeleton>
      </p>
    </div>

      <PuSkeleton :loading="isLoading" :count="1" width='120px'>      
        <span class="link">{{linkTitle}}</span>
      </PuSkeleton>
      </b-card>
  </router-link>

  <b-button  class="btn-post" :to="{name: 'desc-news', params: { userId: this.link}}" @click.prevent="openNews" variant="link" v-else>
    <b-card class="card-post">
      <div>
        <p class="date">
          <PuSkeleton :loading="isLoading" :count="1" width='90px'>                        
            {{ date | moment(true) }}
          </PuSkeleton>
        </p>
        <h4 class="title">
          <PuSkeleton :loading="isLoading" :count="1">                                
            {{title}}
          </PuSkeleton>  
        </h4>
        <p class="desc">
          <PuSkeleton :loading="isLoading" :count="3">        
            {{desc}}
          </PuSkeleton>
        </p>
      </div>
      
        <PuSkeleton :loading="isLoading" :count="1" width='120px'>      
          <span class="link">{{linkTitle}}</span>
        </PuSkeleton>
      </b-card>
  </b-button>

</template>


<script>
import moment from 'moment'
import {mapGetters} from "vuex";
moment.locale('fr');
//
export default {
  name: "CardPost",
  components:{ 
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ])
  },
  props:{
      date:{
        type:String,
        default:"27 avril 2020"
      },     
      title:{
        type:String,
        default:'Fermentum nisi elit, at porta orci vulputate quis.'
      },
      desc:{
        type:String,
        default:'Fermentum nisi elit, at porta orci vulputate quis.'
      },
      linkTitle:{
        type:String,
        default:'En savoir plus'
      },
      link:{
        type:String,
        default:'#'
      },
      isLoad:{
        type:Boolean,
        default: true
      },      
  },
  data(){
    return {
        isLoading:true,
        isMobile:false
    }
  },
  created(){
    this.isLoading = this.isLoad;  
    this.isMobile = this.getIsMobile;
  },
  methods:{
    moment: function (date,year) {
      return moment(date,year);
    },
    openNews(){
      this.$router.push({ name: 'desc-news-mobile', params: { userId: this.link}}).catch(()=>{});
      //this.isMobile ? this.$router.push({ name: 'mobile', params: { subcat: 5 }}).catch(()=>{}) : this.$router.push({ name: 'desc-news-mobile', params: { userId: this.link}}).catch(()=>{});
      this.$store.dispatch('showFooter',false);
    }
  },
  filters: {
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do MMMM YYYY';
      return moment(date).format($format);
    }
  },
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;    
    },
    getIsMobilet(){
      this.isMobile = this.getIsMobile;
    }
  },     
}
</script>
